"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagCloseButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../Icon/index");
var _TagCloseButton = require("./TagCloseButton.styles");
/**
 * A close button for `Tag` components.
 *
 * @since 8.25.0
 */
var TagCloseButton = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_TagCloseButton.StyledTagCloseButton, (0, _extends2.default)({
    ref: forwardedRef
  }, props), /*#__PURE__*/_react.default.createElement(_index.IconCloseCircle, {
    size: "xs"
  }));
});
exports.TagCloseButton = TagCloseButton;
TagCloseButton.displayName = 'TagCloseButton';
TagCloseButton.propTypes = {
  /**
   * The spoken label when targeted by a screen reader.
   */
  'aria-label': _propTypes.default.string,
  /**
   * The button type, with default `"button"`.
   */
  'type': _propTypes.default.string
};
TagCloseButton.defaultProps = {
  'aria-label': 'Remove tag',
  'type': 'button'
};